/**
 * @generated SignedSource<<2e7c508060ca943de3d3d192bd23c3cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublishState = "ARCHIVED" | "DELETED" | "DRAFT" | "PUBLISHED" | "%future added value";
export type TodoState = "CHECKED" | "DISMISSED" | "UNCHECKED" | "%future added value";
export type ItemViewer_updatePageMutation$variables = {
  data?: string | null;
  pageId: string;
};
export type ItemViewer_updatePageMutation$data = {
  readonly updatePage: {
    readonly pageUpdated: {
      readonly data: UnknownJSON | null;
      readonly id: string;
      readonly todos: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: "Todo";
            readonly assignee: {
              readonly id: string;
            } | null;
            readonly documentNode: {
              readonly id: string;
              readonly " $fragmentSpreads": FragmentRefs<"TodoCard_page">;
            };
            readonly dueDate: DateString  | null;
            readonly id: string;
            readonly isListed: boolean;
            readonly publishState: PublishState;
            readonly state: TodoState;
            readonly text: UnknownJSON | null;
            readonly " $fragmentSpreads": FragmentRefs<"TodoAssignee_todo" | "TodoDueDate_todo">;
          } | null;
        }>;
      } | null;
    };
  } | null;
};
export type ItemViewer_updatePageMutation = {
  response: ItemViewer_updatePageMutation$data;
  variables: ItemViewer_updatePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "data"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      },
      {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "data",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v8 = [
  (v3/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueDate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishState",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListed",
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = [
  (v3/*: any*/),
  (v14/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ItemViewer_updatePageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PagesUpdateMutationPayload",
        "kind": "LinkedField",
        "name": "updatePage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "pageUpdated",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "TodoConnection",
                "kind": "LinkedField",
                "name": "todos",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Todo",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "TodoDueDate_todo"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "TodoAssignee_todo"
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FolderItem",
                            "kind": "LinkedField",
                            "name": "documentNode",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "TodoCard_page"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "assignee",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "todos(first:500)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ItemViewer_updatePageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PagesUpdateMutationPayload",
        "kind": "LinkedField",
        "name": "updatePage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "pageUpdated",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "TodoConnection",
                "kind": "LinkedField",
                "name": "todos",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Todo",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AuthorizationResult",
                            "kind": "LinkedField",
                            "name": "canSchedule",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FolderItem",
                            "kind": "LinkedField",
                            "name": "documentNode",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Space",
                                "kind": "LinkedField",
                                "name": "space",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v8/*: any*/),
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v8/*: any*/),
                                    "type": "PendingFile",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "ilSpace",
                                    "args": null,
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "ownershipSpace",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v14/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Color",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "light",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "dark",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "ilEvent",
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "ownershipEvent",
                                    "plural": false,
                                    "selections": (v15/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "ilFolders",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 1
                                      }
                                    ],
                                    "concreteType": "FolderConnection",
                                    "kind": "LinkedField",
                                    "name": "ownershipFolders",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Folder",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": (v15/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "ownershipFolders(first:1)"
                                  }
                                ],
                                "type": "HasOwnerPermissionsInterface",
                                "abstractKey": "__isHasOwnerPermissionsInterface"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "assignee",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "email",
                                "storageKey": null
                              },
                              {
                                "alias": "avatar",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "width",
                                    "value": 750
                                  }
                                ],
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "image",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "image(width:750)"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "roles",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Genealogy__Person",
                                "kind": "LinkedField",
                                "name": "genealogyPerson",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v13/*: any*/),
                                    "type": "MemberDeletedStatus",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AuthorizationResult",
                            "kind": "LinkedField",
                            "name": "canAssign",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "todos(first:500)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d078e23002a4e69e29bd0c2ffba0143",
    "id": null,
    "metadata": {},
    "name": "ItemViewer_updatePageMutation",
    "operationKind": "mutation",
    "text": "mutation ItemViewer_updatePageMutation(\n  $pageId: ID!\n  $data: String\n) {\n  updatePage(input: {pageId: $pageId, data: $data}) {\n    pageUpdated {\n      id\n      data\n      todos(first: 500) {\n        edges {\n          node {\n            id\n            __typename\n            ...TodoDueDate_todo\n            ...TodoAssignee_todo\n            text\n            documentNode {\n              id\n              ...TodoCard_page\n            }\n            assignee {\n              id\n            }\n            state\n            dueDate\n            publishState\n            isListed\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AssignTodoModal_todo on Todo {\n  id\n  documentNode {\n    space {\n      id\n    }\n    id\n  }\n  assignee {\n    id\n    name\n    ...UserHandle_member\n    ...UserAvatar_member\n  }\n}\n\nfragment ItemLocationInfo_item on HasOwnerPermissionsInterface {\n  __isHasOwnerPermissionsInterface: __typename\n  ilSpace: ownershipSpace {\n    id\n    name\n    color {\n      light\n      dark\n    }\n  }\n  ilEvent: ownershipEvent {\n    id\n    name\n  }\n  ilFolders: ownershipFolders(first: 1) {\n    nodes {\n      id\n      name\n    }\n  }\n}\n\nfragment TodoAssignee_todo on Todo {\n  id\n  ...AssignTodoModal_todo\n  assignee {\n    id\n    name\n    ...UserHandle_member\n    ...UserAvatar_member\n  }\n  canAssign {\n    value\n  }\n}\n\nfragment TodoCard_page on FolderItem {\n  id\n  name\n  content {\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on PendingFile {\n      id\n    }\n  }\n  ...ItemLocationInfo_item\n}\n\nfragment TodoDueDateModal_todo on Todo {\n  id\n  dueDate\n}\n\nfragment TodoDueDate_todo on Todo {\n  id\n  ...TodoDueDateModal_todo\n  dueDate\n  canSchedule {\n    value\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar: image(width: 750) {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n  genealogyPerson {\n    id\n  }\n  status {\n    __typename\n    ... on MemberDeletedStatus {\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ae8817471394fe16b1445dd8a57ec8a";

export default node;
